import FilterValues from './filtervalues.js';
import ColorSelectorFilter from "./colorselectorfilter.js";
import SelectedFilters from "./selectedfilters.js";
import PriceRangeFilter from "./pricerangefilter.js";
import SubSearchFilter from "./subsearchfilter.js";
import ProductQuantityFilter from "./productquantityfilter.js";
import UpdateFilterUrl from "./updatefilterurl.js";
import FilterUIHelpers from "./filteruihelpers.js";
import Accordions4i from "../../../common/accordions25.js";
import DataService from "./dataservice.js";
import { prodListValues } from './shared.js';

const overflow = 10;
const menuContainer = document.getElementById('menuContainer');
const filterMenuMobile = document.getElementById('filterMenuMobile');
const hiddenTags = document.getElementById('hiddenTags');
const mobileFilterDropDown = document.getElementById('filterDropDown');
const productContainer = document.getElementById('productContainer');
const filterAccordions = new Accordions4i();

var openMenuOption;

class FilterMenu {
    get getMenuContainer() {
        return menuContainer;
    };

    get openMenuOption() {
        return openMenuOption;
    };

    // Pass in false if the filter does not need to be logged
    markSelected(element, logFilter) {
        if (FilterValues.isColorId(element.id)) {
            ColorSelectorFilter.update(element);
        } else {
            if (typeof (logFilter) === 'undefined') logFilter = true;
            element.checked = true;
            FilterValues.addFilter(element.id, logFilter);
            SelectedFilters.addToSelectedFilter(element);
        }
    };

    markUnSelected(element) {
        element.checked = false;
        FilterValues.removeFilter(element.id);
        SelectedFilters.removeFromSelectedFilter(element);
    };

    setFilterOrder(id, logFilter) {
        if (typeof (logFilter) === 'undefined') logFilter = true;
        const element = document.getElementById('sortDropDown');
        element.value = id;
        FilterValues.addFilter(id, logFilter);
    };

    setPageSize(id) {
        document.getElementById('itemsPerPageDropDown').value = id;
        FilterValues.addPageSize(id);
    };

    markGroupUnSelectedFilter(list) {
        var element;
        for (var i = 0; i < list.length; i++) {
            element = document.getElementById(list[i]);
            element.checked = false;
        }
    };

    unSelectAllFilters(updateUrl) {
        const colorFilterValues = FilterValues.getColorFilter();
        var colorValuesWithElementID = [];
        for (var i = 0; i < colorFilterValues.length; i++) {
            colorValuesWithElementID.push(FilterValues.getColorElementId(colorFilterValues[i]));
        }

        const ratingFilterValues = FilterValues.getRatingFilter();
        var ratingValuesWithElementID = [];
        for (var i = 0; i < ratingFilterValues.length; i++) {
            ratingValuesWithElementID.push(FilterValues.getRatingElementId(ratingFilterValues[i]));
        }

        const productTimeFilterValues = FilterValues.getProdTimeFilter();
        var productTimeValuesWithElementID = [];
        for (var i = 0; i < productTimeFilterValues.length; i++) {
            productTimeValuesWithElementID.push(FilterValues.getProductionTimeElementId(productTimeFilterValues[i]));
        }

        const imprintLocationCountFilterValues = FilterValues.getImprintLocationCountFilter();
        var imprintLocationCountValuesWithElementID = [];
        for (var i = 0; i < imprintLocationCountFilterValues.length; i++) {
            imprintLocationCountValuesWithElementID.push(FilterValues.getImprintLocationCountElementId(imprintLocationCountFilterValues[i]));
        }

        const imprintColorCountFilterValues = FilterValues.getImprintColorCountFilter();
        var imprintColorCountValuesWithElementID = [];
        for (var i = 0; i < imprintColorCountFilterValues.length; i++) {
            imprintColorCountValuesWithElementID.push(FilterValues.getImprintColorCountElementId(imprintColorCountFilterValues[i]));
        }

        const tagFilterValues = FilterValues.getTagFilter();
        var tagValuesWithElementID = [];
        for (var i = 0; i < tagFilterValues.length; i++) {
            tagValuesWithElementID.push(FilterValues.getTagElementId(tagFilterValues[i]));
        }

        // Unselect current filtering.
        this.markGroupUnSelectedFilter(ratingValuesWithElementID);
        this.markGroupUnSelectedFilter(productTimeValuesWithElementID);
        this.markGroupUnSelectedFilter(imprintLocationCountValuesWithElementID);
        this.markGroupUnSelectedFilter(imprintColorCountValuesWithElementID);
        this.markGroupUnSelectedFilter(tagValuesWithElementID);
        ColorSelectorFilter.clear(colorValuesWithElementID);
        if (document.getElementById('PriceRange') !== null) {
            PriceRangeFilter.clear();
        }
        SubSearchFilter.clear();

        ProductQuantityFilter.clear();

        // Remove all filter values.
        FilterValues.clearFilters();

        // Remove all values from the table.
        SelectedFilters.removeAllFromSelectedFilter();

        if (updateUrl) {
            // Update the filter url, products and other information.
            UpdateFilterUrl.update(FilterValues, prodListValues, false);
        }
    };

    selectMainMenu(menu) {
        menu.classList.add('active');
        menu.setAttribute('aria-expanded', 'true');

        var element = document.getElementById(menu.getAttribute('aria-controls'));
        element.classList.remove('hide');

        var listItems = element.querySelectorAll('li:not(.hide)');

        if (listItems.length) {
            setTimeout(function () {
                listItems[0].children[0].focus();
            }, 100);
            listItems[0].children[0].addEventListener('keydown', this.shiftTabKeyPress);
            listItems[listItems.length - 1].children[0].addEventListener('keydown', this.tabKeyPress);
        }
    };

    unSelectMainMenu(menu) {
        menu.classList.remove('active');
        menu.setAttribute('aria-expanded', 'false');

        var element = document.getElementById(menu.getAttribute('aria-controls'));

        var listItems = element.querySelectorAll('li:not(.hide)');

        if (listItems.length) {
            listItems[0].children[0].removeEventListener('keydown', this.shiftTabKeyPress);
            listItems[listItems.length - 1].children[0].addEventListener('keydown', this.tabKeyPress);
        }

        element.classList.add('hide');

        Array.prototype.forEach.call(menuContainer.getElementsByClassName('filterMenu'), (el) => {
            this.hideFilterOption(el);
        });
    };

    hideFilterOption(element) {
        if (element.classList.contains('overflow')) {
            element.classList.add('hideOnSmallAndMedium'); //todo remove
            element.classList.add('show-md');
        } else {
            element.classList.add('showOnLarge'); //todo remove
            element.classList.add('show-md');
        }
    };

    selectFilterMenu(menu) {
        if (menu) {
            menu.classList.remove('showOnLarge'); //todo remove
            menu.classList.remove('show-md');
            menu.classList.remove('hideOnSmallAndMedium'); //todo remove
            menu.classList.remove('show-md');
            menu.classList.remove('hide');

            const listItems = menu.querySelectorAll('li:not(.hide)');

            if (listItems.length) {
                listItems[0].children[0].focus();
                listItems[0].children[0].addEventListener('keydown', this.shiftTabKeyPress);
                listItems[listItems.length - 1].children[0].addEventListener('keydown', this.tabKeyPress);
            } else {
                openMenuOption = menu;
                menu.querySelector('.filterMenuSelect').disabled = false;
                menu.querySelector('.filterMenuSelect').focus();
                menu.querySelector('.filterMenuSelect').addEventListener('keydown', this.shiftTabKeyPress);

                Array.prototype.forEach.call(menu.querySelectorAll('.lastObject'), (element) => {
                    element.addEventListener('keydown', this.tabKeyPress);
                });
            }
        }
    };

    unSelectFilterMenu(element) {
        const listItems = element.parentElement.parentElement.querySelectorAll('li:not(.hide)');

        if (listItems.length) {
            listItems[0].children[0].removeEventListener('keydown', this.shiftTabKeyPress);
            listItems[listItems.length - 1].children[0].removeEventListener('keydown', this.tabKeyPress);
        }

        var parent = element.parentElement.parentElement;

        if (parent.classList.contains('filterMenu')) {
            this.hideFilterOption(parent);
            parent.querySelector('.filterMenuSelect').removeEventListener('keydown', this.shiftTabKeyPress);
            parent.querySelector('.filterMenuSelect').disabled = true;

            Array.prototype.forEach.call(parent.querySelectorAll('.lastObject'), (element) => {
                element.removeEventListener('keydown', this.tabKeyPress);
            });
        } else {
            parent.classList.add('hide');
        }
    };

    markSelectedReload(currentIds, newIds, getId) {
        var filters = '';

        for (var i = 0; i < newIds.length; i++) {
            if (currentIds.indexOf(newIds[i]) === -1) {
                filters += '#' + getId(newIds[i]) + ',';
            }
        }

        if (filters.length) {
            var list = document.querySelectorAll(filters.substr(0, filters.length - 1));

            for (var j = 0; j < list.length; j++) {
                this.markSelected(list[j], false);
            }
        }
    };

    markUnSelectedReload(currentIds, newIds, getId, endIndex) {
        var filters = '';

        for (var i = 0; i < endIndex; i++) {
            if (newIds.indexOf(currentIds[i]) === -1) {
                filters += '#' + getId(currentIds[i]) + ',';
            }
        }

        if (filters.length) {
            var list = document.querySelectorAll(filters.substr(0, filters.length - 1));

            for (var j = 0; j < list.length; j++) {
                this.markUnSelected(list[j]);
            }
        }
    };

    updateMenuSelections(options) {
        const mainMenu = filterMenuMobile.querySelectorAll('a:not(.moreLink):not(.noHide)');
        var mainMenuCnt = 0;

        this.addTagFilters();

        for (var i = 0; i < mainMenu.length; i++) {
            if (this.updateMenuOptions(mainMenu[i].getAttribute('aria-controls'), options)) {
                mainMenu[i].parentElement.classList.add('hide');
                mainMenu[i].parentElement.classList.remove('overflow');
            } else {
                if ((++mainMenuCnt) <= overflow) {
                    mainMenu[i].parentElement.classList.remove('hide');
                    mainMenu[i].parentElement.classList.remove('overflow');
                } else {
                    mainMenu[i].parentElement.classList.add('hide');
                    mainMenu[i].parentElement.classList.add('overflow');
                }
            }
        }

        if (mainMenuCnt > overflow) {
            this.resetMoreLink(filterMenuMobile.getElementsByClassName('moreLink'));
        } else {
            Array.prototype.forEach.call(filterMenuMobile.getElementsByClassName('moreLink'), function (el) {
                el.parentElement.classList.add('hide');
            });
        }
    };

    updateMenuOptions(menuId, options) {
        // Check if options is defined and has the menuId property
        // console.log(options.hasOwnProperty(menuId));
        if (!options || !options.hasOwnProperty(menuId)) {
            return false; // Return false if options is undefined or menuId is not a property of options
        }

        const filterOptions = options[menuId];

        if (menuId === 'colorFilter') {
            ColorSelectorFilter.updateCounts(filterOptions);
            return false;
        }

        if (document.getElementById(menuId)) {
            const filters = [].slice.call(document.getElementById(menuId).querySelectorAll('input[type=checkbox], input[type=radio]'));
            if (filters.length) {
                let optionCnt;
                let filterId = '';
                for (let i = 0; i < filters.length; i++) {
                    optionCnt = 0;
                    filterId = FilterValues.getFilterId(filters[i].id);
                    if (filterId && filterOptions) {
                        for (let j = 0; j < filterOptions.length; j++) {
                            if (filterOptions[j].Id === filterId) {
                                optionCnt = filterOptions[j].Count;
                                break;
                            }
                        }

                    }
                    FilterUIHelpers.getUpdatedFilterCount(document.getElementById(filters[i].id + '_label'), optionCnt, filters[i].getAttribute('data-filter'));
                }
            }
            return false;
        }
        return false;
    };

    resetMoreLink(moreLink) {
        if (moreLink.length) {
            var element = moreLink[0];
            element.parentElement.classList.remove('hide');

            if (element.getAttribute('aria-expanded') === 'true') {
                var newLabel = element.innerHTML.replace("Less", "More");
                element.innerHTML = newLabel;
                element.querySelector("svg").setAttribute("class", "rotate180");
                element.setAttribute('aria-expanded', 'false');
            }
        }
    };

    tabKeyPress(e) {
        if (e.which === 9 && !e.shiftKey) {
            const element = this.parentElement.parentElement;
            const listItems = element.querySelectorAll('li:not(.hide)');

            if (listItems.length) {
                e.preventDefault();
                listItems[0].children[0].focus();
            } else if (mobileFilterDropDown.classList.contains('active') && getComputedStyle(element.querySelector('.filterMenuSelect'), null).display !== 'none') {
                e.preventDefault();
                element.querySelector('.filterMenuSelect').focus();
            }
        }
    };

    shiftTabKeyPress(e) {
        if (e.which === 9 && e.shiftKey) {
            e.preventDefault();

            mobileFilterDropDown.focus();
        }
    };

    toggleFilterOptions(e) {
        e.preventDefault();
        const btn = e.currentTarget;

        if (menuContainer.classList.contains('hide')) {
            menuContainer.classList.remove('hide');
            productContainer.classList.remove('c-md-13');
            productContainer.classList.add('c-md-10');
            btn.setAttribute('aria-expanded', true);

            const accordionHeader = menuContainer.querySelector('.filterMenu button.accordionHeader');
            if (accordionHeader) {
                accordionHeader.focus();
                accordionHeader.removeEventListener("click", this.toggleFilterOptions);
            }
        } else {
            menuContainer.classList.add('hide');
            productContainer.classList.add('c-md-13');
            productContainer.classList.remove('c-md-10');
            btn.setAttribute('aria-expanded', false);
        }

        FilterUIHelpers.toggleButtonLabel(btn);
    };

    toggleTagFilters(e) {
        e.preventDefault();
        const btn = e.currentTarget;

        var filterId = "MoreFiltersButton", filtervalue = "More";

        const expanded = (btn.getAttribute('aria-expanded') === 'true');

        if (mobileFilterDropDown.classList.contains('active')) {
            mobileFilterDropDown.click();
        }

        btn.setAttribute('aria-expanded', !expanded);
        var newLabel = btn.innerHTML;

        //a/b test addition:
        /*const betterChoicesABFilter = document.querySelector(".abBetterChoicesFilter");
        if(betterChoicesABFilter && betterChoicesABFilter.classList.contains("hide")){
            betterChoicesABFilter.classList.remove("hide");
        }else if(betterChoicesABFilter){
            betterChoicesABFilter.classList.add("hide");
        }*/

        if (expanded) {
            filtervalue = "Less";
            btn.innerHTML = newLabel.replace("Less", "More");
            btn.querySelector("svg").setAttribute("class", "rotate180");
            DataService.filterLog(filterId, filtervalue);
        } else {
            btn.innerHTML = newLabel.replace("More", "Less");
            btn.querySelector("svg").removeAttribute("class");
            DataService.filterLog(filterId, filtervalue);
            this.addTagFilters();
            setTimeout(function () {
                //a/b test addition:
                //if(betterChoicesABFilter) betterChoicesABFilter.querySelector("button").focus();
                //else document.getElementById("tagFiltersDiv").querySelector("button").focus();
                document.getElementById("tagFiltersDiv").querySelector("button").focus();
            }, 100);
        }

        Array.prototype.forEach.call(menuContainer.querySelectorAll('.filterMenu.overflow'), function (element) {
            if (expanded) {
                element.classList.add('hide');
                element.classList.remove('hideOnSmallAndMedium'); //todo remove
                element.classList.remove('show-md');
            } else {
                element.classList.remove('hide');
                element.classList.add('hideOnSmallAndMedium'); //todo remove
                element.classList.add('show-md');
            }
        });

        filterAccordions.init(document.getElementById("mainFilters"));
    };

    moreLinkClickEvent(event, element) {
        event.preventDefault();

        var parent = element.parentElement.parentElement;
        var newLabel;

        if (element.getAttribute('aria-expanded') === 'true') {
            Array.prototype.forEach.call(parent.getElementsByClassName('overflow'), function (el) {
                el.classList.add('hide');
            });
            newLabel = element.innerHTML.replace("Less", "More");
            element.setAttribute('aria-expanded', 'false');
            element.innerHTML = newLabel;
            element.querySelector("svg").setAttribute("class", "rotate180");
        } else {
            var overflow = parent.getElementsByClassName('overflow');

            if (overflow.length) {
                Array.prototype.forEach.call(overflow, function (el) {
                    el.classList.remove('hide');
                });

                overflow[0].children[0].focus();
            }
            newLabel = element.innerHTML.replace("More", "Less");
            element.setAttribute('aria-expanded', 'true');
            element.innerHTML = newLabel;
            element.querySelector("svg").removeAttribute("class");
        }
    };

    checkboxClickEvent(element) {
        if (element.checked) {
            this.markSelected(element);
        } else {
            this.markUnSelected(element);
        }

        if (mobileFilterDropDown.classList.contains('active')) {
            mobileFilterDropDown.click();
        }

        UpdateFilterUrl.update(FilterValues, prodListValues, false);
    };

    mobileMenuSelectEvent(event, element) {
        event.preventDefault();

        if (document.querySelector(".openedFilter")) {
            document.querySelector(".openedFilter").setAttribute("aria-expanded", "false");
            document.querySelector(".openedFilter").classList.remove("openedFilter");
        }
        this.unSelectFilterMenu(element);
        this.selectFilterMenu(document.getElementById(element.getAttribute('aria-controls')));
    };

    events() {
        Array.prototype.forEach.call(menuContainer.getElementsByClassName('filterMenuSelect'), function (el) {
            el.addEventListener('click', function (e) {
                this.mobileMenuSelectEvent(e, this);
            }.bind(this));
        }.bind(this));

        Array.prototype.forEach.call(menuContainer.getElementsByClassName('filterMainMenuSelect'), function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                el.setAttribute("aria-expanded", "true");
                el.classList.add("openedFilter");
                this.unSelectFilterMenu(this.parentElement);
                this.selectFilterMenu(document.getElementById(this.getAttribute('aria-controls')));
                if (el != document.getElementById("a_subSearchFilter")) {
                    document.getElementById('pnlSubSearch').scrollIntoView({ behavior: 'smooth' });
                } else {
                    document.getElementById("subSearchContent").classList.add("open");
                    document.getElementById("txtInnerSearch").focus();
                }
            });
        });

        Array.prototype.forEach.call(menuContainer.getElementsByClassName('moreLink'), function (el) {
            el.addEventListener('click', function (e) {
                this.moreLinkClickEvent(e, el);
            }.bind(this));
        }.bind(this));

        Array.prototype.forEach.call(menuContainer.querySelectorAll('input[type=checkbox]'), function (el) {
            el.addEventListener('change', function () {
                this.checkboxClickEvent(el);
            }.bind(this));
        }.bind(this));
    };

    addTagFilters() {
        if (hiddenTags && hiddenTags.textContent.length) {
            const tagFilters = document.getElementById('tagFiltersDiv');
            tagFilters.innerHTML = hiddenTags.textContent;
            hiddenTags.textContent = '';

            Array.prototype.forEach.call(tagFilters.getElementsByClassName('moreLink'), function (el) {
                el.addEventListener('click', function (e) {
                    this.moreLinkClickEvent(e, el);
                }.bind(this));
            }.bind(this));

            Array.prototype.forEach.call(tagFilters.querySelectorAll('input[type=checkbox]'), function (el) {
                el.addEventListener('change', function () {
                    this.checkboxClickEvent(el);
                }.bind(this));
            }.bind(this));

            Array.prototype.forEach.call(tagFilters.getElementsByClassName('filterMenuSelect'), function (el) {
                el.addEventListener('click', function (e) {
                    this.mobileMenuSelectEvent(e, el);
                }.bind(this));
            }.bind(this));

            //a/b test addition:
            /*const betterChoices = document.querySelector(".betterChoicesABFilter");
            if(betterChoices && betterChoices.classList.contains("hide")){
                betterChoices.classList.remove("hide");
            }*/
        }
    };
}

export default new FilterMenu();